import styled from 'styled-components';

const ContentWrap = styled.div`
    background-color: ${({ theme }) => theme.colors.Background};
    min-height: ${(props) => props.minHeight ? `${props.minHeight}px` : 'unset'};
`;

export default ContentWrap;
